import { getAppConstants } from '@/lib/getAppConstants';

/**
 * Identifies local environment when
 *
 * - environment or .env contains following variable `OPM_COCKPIT_LOCAL=true`
 * - frontend baseurl is equals `localhost` or `127.0.01`
 */
export const isLocal = () => {
  const { OPM_COCKPIT_LOCAL: localFlag } = getAppConstants();

  // Ensures that only the local environment is identified via localhost.
  const localServer =
    location.hostname === 'localhost' || location.hostname === '127.0.0.1';

  return localServer && localFlag;
};
